module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_Black_MockedUp.66dba990.jpg";